export class Segmento {
    id: string
    nome: string
    idAssociacao: string
}